module.exports = __webpack_public_path__ + "static/8-d92442af81414ac1684734c890e7d227.jpg";